import { FC } from 'react';
import styled from 'styled-components';
import { Avatar } from 'components/atoms/avatar';
import { AvatarProps } from 'components/atoms/avatar/types';

type FallbackAvatarProps = AvatarProps & { fallbackUrl: string };

export const AvatarWithFallback = styled<FC<FallbackAvatarProps>>(Avatar).attrs(
  (props) => ({
    src: props.src || props.fallbackUrl,
  }),
)``;
